import type { LucideIcon } from 'lucide-react';
import type { ReactElement } from 'react';

/**
 * Pictogramme Lucide, la famille du mobile (ADR 0021) et de la maquette.
 *
 * Il existe pour fixer ce qu'aucun site d'appel ne doit choisir : le **trait de
 * 2 sur la grille de 24** de la bibliotheque de composants — mis a l'echelle
 * avec l'icone, comme dans la maquette, ou une icone de 16 garde la meme
 * silhouette qu'a 24 — et la couleur, **heritee** (`currentColor`) du texte qui
 * l'entoure, donc du theme.
 *
 * Decoratif par defaut (`aria-hidden`) : l'icone accompagne un libelle qui dit
 * deja le sens. `label` n'est a donner que pour une icone seule porteuse de
 * sens, et c'est rarement le bon choix — un bouton d'icone se nomme par son
 * propre `aria-label`.
 */
export interface IconProps {
  readonly icon: LucideIcon;
  /** Taille en pixels : 14 dans un badge, 16-18 dans un bouton, 20 par defaut. */
  readonly size?: number;
  readonly label?: string;
}

export const ICON_STROKE_WIDTH = 2;

export const Icon = ({ icon: Glyph, size = 20, label }: IconProps): ReactElement => (
  <Glyph
    size={size}
    strokeWidth={ICON_STROKE_WIDTH}
    focusable="false"
    {...(label === undefined ? { 'aria-hidden': true } : { role: 'img', 'aria-label': label })}
    style={{ flexShrink: 0 }}
  />
);
